import {
  BookOutlined,
  EditOutlined,
  SafetyCertificateOutlined,
  AlertOutlined,
  DashboardOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const legalSidebar: SidebarConfig = {
  module: 'legal',
  titleKey: 'common:nav.legal',
  icon: <BookOutlined />,
  sections: [
    {
      key: 'matters',
      labelKey: 'legal:sidebar.sections.matters',
      items: [
        { key: 'redlining', path: '/legal/redlining', labelKey: 'legal:pages.redlining', icon: <EditOutlined /> },
        { key: 'compliance', path: '/legal/compliance', labelKey: 'legal:pages.compliance', icon: <SafetyCertificateOutlined /> },
        { key: 'disputes', path: '/legal/disputes', labelKey: 'legal:pages.disputes', icon: <AlertOutlined /> },
      ],
    },
    {
      key: 'overview',
      labelKey: 'legal:sidebar.sections.overview',
      items: [
        { key: 'dashboard', path: '/legal/dashboard', labelKey: 'legal:pages.dashboard', icon: <DashboardOutlined /> },
      ],
    },
  ],
};
